// Shared availability constants + helpers (mirrors backend derivation logic)

export const SHIFT_META = [
  { key: 'day', label: 'Day', time: '7:00 AM – 3:00 PM', code: '7a-3p' },
  { key: 'swing', label: 'Swing', time: '11:00 AM – 7:00 PM', code: '11a-7p' },
  { key: 'evening', label: 'Evening', time: '3:00 PM – 11:00 PM', code: '3p-11p' },
  { key: 'overnight', label: 'Overnight', time: '11:00 PM – 7:00 AM', code: '11p-7a' },
];

export const STATE_STYLES = {
  preferred: { label: 'Preferred', bg: '#D7F2E7', border: '#1D9E75', text: '#116649', dot: '#1D9E75' },
  available: { label: 'Available', bg: '#DCEDFB', border: '#3B82C4', text: '#1E5A8E', dot: '#3B82C4' },
  limited: { label: 'Limited', bg: '#FDF0D2', border: '#D99E22', text: '#8A6210', dot: '#D99E22' },
  unavailable: { label: 'Unavailable', bg: '#FBE1E1', border: '#D25454', text: '#912F2F', dot: '#D25454' },
  no_response: { label: 'Not Completed', bg: '#F1F1F3', border: '#C9C9CE', text: '#6B6B72', dot: '#A5A5AC' },
};

export const SHIFT_STATUS_STYLES = {
  preferred: STATE_STYLES.preferred,
  available: STATE_STYLES.available,
  unavailable: STATE_STYLES.unavailable,
  no_response: STATE_STYLES.no_response,
};

export const SUB_STATUS_STYLES = {
  not_started: { label: 'Not Started', variant: 'secondary' },
  draft: { label: 'Draft', variant: 'outline' },
  submitted: { label: 'Submitted', variant: 'default' },
  reopened: { label: 'Reopened', variant: 'outline' },
  locked: { label: 'Locked', variant: 'secondary' },
  past_due: { label: 'Past Due', variant: 'destructive' },
};

// Derived date-level state — must match backend day_state()
export function dayState(entry) {
  if (!entry) return 'no_response';
  if (entry.unavailable_all_day) return 'unavailable';
  const shifts = entry.shifts || {};
  const vals = Object.values(shifts);
  if (entry.restriction) return 'limited';
  if (vals.includes('preferred')) return 'preferred';
  if (vals.includes('available')) return 'available';
  if (vals.length > 0 && vals.every((v) => v === 'unavailable')) return 'unavailable';
  return 'no_response';
}

export function isDayComplete(entry) {
  return !!(entry && (entry.unavailable_all_day || Object.keys(entry.shifts || {}).length > 0));
}

export function fmtLongDate(d) {
  return new Date(d + 'T00:00:00').toLocaleDateString('en-US', {
    weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
  });
}

export function fmtShortDate(d) {
  return new Date(d + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function fmtDateTime(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
  });
}

export const WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Group a flat list of YYYY-MM-DD dates into Sun→Sat weeks (with null padding)
export function groupIntoWeeks(dates) {
  const weeks = [];
  let current = null;
  dates.forEach((d) => {
    const wd = new Date(d + 'T00:00:00').getDay();
    if (!current || wd === 0) {
      current = new Array(7).fill(null);
      weeks.push(current);
    }
    current[wd] = d;
  });
  return weeks;
}

export function getCurrentUser() {
  try {
    return JSON.parse(localStorage.getItem('currentUser'));
  } catch (_) {
    return null;
  }
}
